import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Order from '../../models/Order'

export interface OrderListState extends PaginatedApiState {
  orders?: Order[]
  isChacoClient?: boolean
}

const OrderList = (state: OrderListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    case 'ORDER_CLEAR':
      return { ...state, orders: null }
    default:
      return requestReducer<OrderListState>('ORDER_LIST')(state, action)
  }
}

export default OrderList
